import { PractitionerConfigurationVerificationResult } from '@dreryk/egabinet-personnel-frontend-api';
import { ConfigurationVerificationResult } from '@dreryk/egabinet-visit-frontend-api';

import { StyledFlex } from '@dreryk/react-components';

import { useGetCurrentHealthcareProviderType } from '~libs.shared.account';

import { AccountConfigurationInfoHelpTextNotification } from './AccountConfigurationInfoHelpTextNotification';
import { HealthcareProviderAccountConfigurationItem } from './HealthcareProviderAccountConfigurationItem';
import { HealthcareProviderAdministratorLackConfigurationStatus } from './HealthcareProviderAdministratorLackConfigurationStatus';
import { P1CertificatesAccountConfigurationItem } from './P1CertificatesAccountConfigurationItem.';
import { PersonalCertificateAccountConfigurationItem } from './PersonalCertificateAccountConfigurationItem';
import { PeselAndProfessionAccountConfigurationItem } from './PeselAndProfessionAccountConfigurationItem';
import { PwzAndSpecializationAccountConfigurationItem } from './PwzAndSpecializationAccountConfigurationItem';
import { StyledAccountConfigurationInfoModalList } from './StyledAccountConfigurationInfoModalList';

type AccountConfigurationInfoModalContentProps = {
   readonly healthcareProviderConfiguration: ConfigurationVerificationResult;
   readonly practitionerConfiguration: PractitionerConfigurationVerificationResult;
   readonly onRedirect?: VoidFunction;
};

export const AccountConfigurationInfoModalContent = (props: AccountConfigurationInfoModalContentProps): JSX.Element => {
   const healthcareProviderType = useGetCurrentHealthcareProviderType();

   return (
      <StyledFlex direction={'column'} gap='24px'>
         <HealthcareProviderAdministratorLackConfigurationStatus
            healthcareProviderDataConfigured={props.healthcareProviderConfiguration.healthcareProviderDataConfigured}
            p1CertificateConfigured={props.healthcareProviderConfiguration.p1CertificateConfigured}
         />

         <StyledFlex gap='12px'>
            <StyledAccountConfigurationInfoModalList>
               <PersonalCertificateAccountConfigurationItem
                  configured={props.practitionerConfiguration.personalCertificateConfigured}
                  onRedirect={props.onRedirect}
               />
               <P1CertificatesAccountConfigurationItem
                  configured={props.healthcareProviderConfiguration.p1CertificateConfigured}
                  onRedirect={props.onRedirect}
                  healthcareProviderType={healthcareProviderType}
               />
               <PwzAndSpecializationAccountConfigurationItem
                  configured={props.practitionerConfiguration.medicalLicenceNumberAndSpecializationConfigured}
                  onRedirect={props.onRedirect}
               />
               <PeselAndProfessionAccountConfigurationItem
                  configured={props.practitionerConfiguration.peselAndParamedicalProfessionConfigured}
                  onRedirect={props.onRedirect}
               />
               <HealthcareProviderAccountConfigurationItem
                  configured={props.healthcareProviderConfiguration.healthcareProviderDataConfigured}
                  onRedirect={props.onRedirect}
                  healthcareProviderType={healthcareProviderType}
               />
            </StyledAccountConfigurationInfoModalList>
         </StyledFlex>

         <AccountConfigurationInfoHelpTextNotification />
      </StyledFlex>
   );
};
